const WECOM_TEST_REDIRECT_KEY = "wecom_test_redirect";
const PROD_ADMIN_API_BASE_URL = "https://api.52choujiang.cn/lotto/admin/api/v1";
const TEST_ADMIN_API_BASE_URL = process.env.VUE_APP_LOTTO_ADMIN_TEST_API_BASE_URL
  || "https://test-lotto.weiyoubot.cn/lotto/admin/api/v1";

function getAdminApiUrl(path) {
  const shouldUseTestApi = typeof window !== "undefined"
    && process.env.NODE_ENV !== "production"
    && Boolean(window.localStorage.getItem(WECOM_TEST_REDIRECT_KEY));
  if (!shouldUseTestApi) {
    return `${PROD_ADMIN_API_BASE_URL}${path}`;
  }
  return new URL(`${TEST_ADMIN_API_BASE_URL}${path}`, window.location.origin).toString();
}

export function getDefaultUserSearchFilters() {
  return {
    user_id: "",
    registration: [],
    usage_time: [],
    start_task_min: -1,
    start_task_max: -1,
    all_task_min: -1,
    all_task_max: -1,
    payStatus: -1,
  };
}

function toStartSeconds(date) {
  if (!date) return "";
  return Math.floor(new Date(date).getTime() / 1000);
}

function toEndSeconds(date) {
  if (!date) return "";
  return Math.floor(new Date(date).getTime() / 1000) + 86399;
}

function hasRangeValue(value) {
  return value !== "" && value !== null && value !== undefined;
}

function copyNonEmptyNumber(request, filters, key) {
  if (hasRangeValue(filters[key])) {
    request[key] = filters[key];
  }
}

function isInvalidBoundedRange(min, max) {
  return min !== -1 && max !== -1 && min >= max;
}

export function validateUserSearchFilters(filters) {
  if (isInvalidBoundedRange(filters.start_task_min, filters.start_task_max)) {
    return "进行中查询范围设置有误!";
  }

  if (isInvalidBoundedRange(filters.all_task_min, filters.all_task_max)) {
    return "活动总数查询范围设置有误!";
  }

  return "";
}

export function buildUserSearchRequest(filters, pagination, sort = null) {
  const request = {};

  if (filters.user_id) {
    request.user_id = filters.user_id;
  }

  if (filters.registration && filters.registration.length === 2) {
    request.stime = toStartSeconds(filters.registration[0]);
    request.etime = toEndSeconds(filters.registration[1]);
  }

  if (filters.usage_time && filters.usage_time.length === 2) {
    request.use_stime = toStartSeconds(filters.usage_time[0]);
    request.use_etime = toEndSeconds(filters.usage_time[1]);
  }

  copyNonEmptyNumber(request, filters, "start_task_min");
  copyNonEmptyNumber(request, filters, "start_task_max");
  copyNonEmptyNumber(request, filters, "all_task_min");
  copyNonEmptyNumber(request, filters, "all_task_max");

  if (filters.payStatus !== -1 && filters.payStatus !== "" && filters.payStatus !== null && filters.payStatus !== undefined) {
    request.is_vip = Number(filters.payStatus) === 1;
  }

  request.page = pagination.page;
  request.page_size = pagination.pageSize;

  if (sort && sort.prop && sort.order) {
    request.sort = {
      sort_key: sort.prop,
      sort_type: sort.order === "ascending" ? 1 : -1,
    };
  }

  return request;
}

export function normalizeUserListItem(user) {
  return {
    id: user.uid,
    uid: user.uid,
    unionid: user.unionid,
    user_id: user.user_id,
    mobile: user.mobile,
    username: user.username || `用户${user.id || user.uid}`,
    status: user.status || "active",
    trial_status: user.trial_str,
    trial_str: user.trial_str,
    pay_status: user.pay_status || (user.is_vip ? "付费中" : "未付费"),
    isVerified: user.is_verified || false,
    has_ban: Number(user.has_ban || 0),
    is_banned: Boolean(user.has_ban || user.is_banned),
    ban_reason: user.ban_reason || "",
    is_vip: user.is_vip || false,
    join_by_h5: user.join_by_h5,
    live_trial_setting: user.live_trial_setting || {},
    creating_count: Number(user.all_task_count || 0),
    ongoing_count: Number(user.start_task_count || 0),
    all_task_count: Number(user.all_task_count || 0),
    start_task_count: Number(user.start_task_count || 0),
    createdAt: user.create_time,
    create_time: user.create_time,
    visitAt: user.last_use_time,
    last_use_time: user.last_use_time,
    lastLogin: user.last_login,
    remark: user.remark,
  };
}

export function getUserRowActions(user) {
  const actions = [
    { key: "background", label: "进入后台", type: "primary" },
    { key: "authority", label: "权限设置", type: "primary" },
    { key: "liveTrial", label: "现场体验权限设置", type: "primary" },
    { key: "transfer", label: "转移VIP权益", type: "success" },
  ];

  if (user.is_banned) {
    actions.push({ key: "unban", label: "解封", type: "warning" });
  } else {
    actions.push({ key: "ban", label: "封禁", type: "danger" });
  }

  return actions;
}

export function getUserBanRequest(user, action, reason = "") {
  const body = {
    uid: user.id,
    status: action === "ban" ? 1 : 0,
  };

  if (action === "ban") {
    body.reason = reason.trim();
  }

  return {
    endpoint: getAdminApiUrl("/user/ban"),
    body,
  };
}
